var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelCognitive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 13.5,
    r: 13.5,
    fill: "#7B1FA2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6274 13.2825C26.6274 10.8747 25.671 8.56563 23.9684 6.86311C22.2659 5.16058 19.9568 4.20412 17.5491 4.20412C15.1413 4.20412 12.8322 5.16058 11.1297 6.86311C9.42717 8.56563 8.4707 10.8747 8.4707 13.2825L13.0782 13.2825C13.0782 12.0967 13.5493 10.9596 14.3877 10.1211C15.2261 9.28267 16.3633 8.81163 17.5491 8.81163C18.7348 8.81163 19.872 9.28267 20.7104 10.1211C21.5489 10.9596 22.0199 12.0967 22.0199 13.2825H26.6274Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M8.47216 13.6217C8.47216 15.228 8.89498 16.8059 9.69812 18.197C10.5013 19.5881 11.6564 20.7432 13.0475 21.5464L15.3849 17.4978C14.7045 17.105 14.1395 16.54 13.7466 15.8596C13.3538 15.1792 13.147 14.4074 13.147 13.6217L8.47216 13.6217Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M13.3268 21.5142C14.6236 22.2629 16.0948 22.6571 17.5923 22.6571C19.0899 22.6571 20.561 22.2629 21.8579 21.5142L19.572 17.5549C18.9701 17.9024 18.2873 18.0853 17.5923 18.0853C16.8973 18.0853 16.2145 17.9024 15.6127 17.5549L13.3268 21.5142Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M22.0756 21.4247C23.4666 20.6215 24.6218 19.4664 25.4249 18.0753C26.2281 16.6842 26.6509 15.1063 26.6509 13.5L21.976 13.5C21.976 14.2857 21.7692 15.0575 21.3764 15.7379C20.9836 16.4183 20.4186 16.9833 19.7381 17.3762L22.0756 21.4247Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 35,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelCognitive);
export default __webpack_public_path__ + "static/media/wheel_cognitive.5e356632.svg";
export { ForwardRef as ReactComponent };